import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-f380c2fa"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "content"
};
const _hoisted_2 = {
  key: 3,
  class: "hs_type"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "室", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "厅", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "卫", -1));
const _hoisted_6 = {
  class: "note"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "注：当您完成提交预约操作后，上门预约时间将不能自行修改，如需变更请在服务人员上门之前拨打服务热线进行人工变更，感谢您的配合！", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_9 = {
  class: "footerBtn"
};
import { ref, getCurrentInstance, nextTick } from "vue";
import { useRouter, useRoute } from "vue-router";
import Date from "../components/date.vue";
import { defineComponent } from "vue";
import commonMethod from '../common/common';
import axios from '../common/http';
const __default__ = defineComponent({
  beforeRouteEnter(to, from, next) {
    if (to.params.su == '' || to.params.su == null || to.params.su.length != 10 || to.params.su == undefined) {
      commonMethod.dialog('出现授权错误', '抱歉通知您,未获得正确的授权信息,请与客服联系进行人工预约,感谢您的配合!', 1);
      return;
    }
    axios.post("https://quanjidj.com/Index/getStId", {
      su: to.params.su
    }).then(res => {
      if (res.data && res.data.st_id <= 0) {
        commonMethod.dialog('预约信息加载异常', '抱歉通知您由于系统繁忙您的数据加载异常,请退出重试,感谢您的配合!', 1);
        return;
      }
      if (res.data.st_id == 5) {
        next({
          path: '/shose/' + to.params.su
        });
      } else if (res.data.st_id == 10) {
        next({
          path: '/cup/' + to.params.su
        });
      } else {
        if (res.data.rs_appid.indexOf("zhycfh") != -1) {
          next({
            path: '/zh/' + to.params.su
          });
        } else {
          next(vm => vm.getData(to.params.su));
        }
      }
    });
  }
});
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'reserve_Street',
  setup(__props, {
    expose: __expose
  }) {
    components: {
      Date;
    }
    const router = useRouter();
    const route = useRoute();
    const {
      proxy
    } = getCurrentInstance();
    // 获取订单信息
    const getData = su => {
      proxy.$api.post(`${proxy.$url}Index/get_soi`, {
        su
      }).then(res => {
        if (res.status == 1) {
          // 已预约并且不是从保全延期页面跳过来
          if (res.reserved == 1 && !(route.query && route.query.type == "repeat")) {
            router.replace({
              path: '/reserved/' + route.params.su
            });
            return;
          }
          initData(res);
        } else {
          commonMethod.dialog('预约信息加载异常', '抱歉通知您，您的订单处于取消状态或由于系统繁忙，数据加载异常,请退出重试,感谢您的配合!', 1);
        }
      }).catch(err => {
        commonMethod.dialog('预约信息加载异常', '抱歉通知您由于系统繁忙您的数据加载异常,请退出重试,感谢您的配合!', 1);
      });
    };
    __expose({
      getData
    }); // 暴露方法，不然上一个script拿不到
    const orderDetail = ref({}); // 订单详情
    const sa_id = ref(0); // 地区id
    const overlayShow = ref(false); // 超90天不可预约
    const isjiadian = ref(false); // 是否是家电
    const brandsList = ref([]); // 家电品牌列表
    const isHood = ref(false); // 是否是油烟机
    const areaSelected = ref(''); // 省市区选中
    const area_selected = ref(''); // 未预约的订单记录第一次的地址，已经预约的订单显示预约地址
    const street = ref(''); // 街道名称
    const address = ref(''); // 详细地址
    const house_type1 = ref(''); // 室
    const house_type2 = ref(''); // 厅
    const house_type3 = ref(''); // 卫
    const resName = ref(''); // 姓名
    const resPhone = ref(''); // 电话
    const remark = ref(''); // 备注
    // 加载页面数据
    const initData = async res => {
      if (res.reserved == 3) {
        commonMethod.dialog('权益已废', '抱歉通知您,您已申请了退积分操作,该权益已废除,如需服务请重新兑换,感谢您的配合!', 1);
        return;
      }
      orderDetail.value = res.orderDetail;
      // 如果超90天，提示不可预约
      if (orderDetail.value.is_over_days) {
        overlayShow.value = true;
        return;
      }
      // 判断是否是家电
      if (orderDetail.value.st_id == 1) {
        isjiadian.value = true;
        // 等于10和11的时候，说明是油烟机
        isHood.value = orderDetail.value.s_id == 10 || orderDetail.value.s_id == 11 || orderDetail.value.s_id == 20 ? true : false;
        if (orderDetail.value.s_id != 12) {
          brandsList.value = res.brands;
        }
      }
      // 地址id和地址选中赋值
      sa_id.value = orderDetail.value.user_map_sa_id ? orderDetail.value.user_map_sa_id : orderDetail.value.res_sa_id ? orderDetail.value.res_sa_id : orderDetail.value.sa_id ? orderDetail.value.sa_id : 0;
      if (orderDetail.value.user_map_province && orderDetail.value.user_map_city && orderDetail.value.user_map_district) {
        areaSelected.value = area_selected.value = orderDetail.value.user_map_province + '/' + orderDetail.value.user_map_city + '/' + orderDetail.value.user_map_district;
      } else if (orderDetail.value.province && orderDetail.value.city && orderDetail.value.district) {
        areaSelected.value = area_selected.value = orderDetail.value.province + '/' + orderDetail.value.city + '/' + orderDetail.value.district;
      } else {
        if (orderDetail.value.rs_appid != "chedd") {
          commonMethod.dialog('可服务区域变更提醒', '抱歉通知您,您兑换的商品可服务区域进行了变更或所选地址异常,请联系客服或选择新的地址进行预约,感谢您的配合!');
        }
      }
      resName.value = orderDetail.value.c_name;
      // resPhone.value = orderDetail.value.res_phone;
      await getArea();
    };
    // 选择家电品牌
    const brand_name = ref(''); // 家电名称
    const brand_id = ref(0); // 家电id
    const showBrand = ref(false); // 家电品牌选择弹窗
    const brandConfirm = e => {
      brand_name.value = e.name;
      brand_id.value = e.value;
      showBrand.value = false;
    };
    // 选择油烟机类型
    const hood_type = ref(0); // 油烟机id
    const hoodsConfirm = e => {
      hood_type.value = e;
    };
    // 选择省市区
    const areaList = ref([]); // 地址列表
    const defaultIndex = ref(''); // 选择地址默认选中
    const showArea = ref(false); // 省市区弹窗
    const city_code = ref(0); // 市级区域码
    const district_code = ref(0); // 区级区域码
    // 获取地址
    const getArea = () => {
      proxy.$api.post(`${proxy.$url}ExpApi/getAreasFromType`, {
        st_id: orderDetail.value.st_id
      }).then(res => {
        let list, province, city, district, i, j, k;
        list = res.data[0];
        if (areaSelected.value) {
          let arr = areaSelected.value.split('/');
          province = arr[0];
          city = arr[1];
          district = arr[2];
          getStreetList();
        }
        // 在数组中找到省市区的序号
        if (province != null && city != null && district != null) {
          i = list.findIndex(item => item.text == province);
          j = list[i].children.findIndex(item => item.text == city);
          k = list[i].children[j].children.findIndex(item => item.text == district);
        } else {
          i = j = k = 0;
        }
        areaList.value = [{
          values: list,
          className: 'province',
          defaultIndex: i
        }, {
          values: list[i].children,
          className: 'city',
          defaultIndex: j
        }, {
          values: list[i].children[j].children,
          className: 'area',
          defaultIndex: k
        }];
        city_code.value = areaList.value[2].values[k].city_code;
        district_code.value = areaList.value[2].values[k].area_code;
      });
    };
    const picker = ref(null);
    // 地址选择联动时触发
    const areaChange = (value, index) => {
      if (index == 0) {
        picker.value.setColumnValues(1, value[index].children);
        picker.value.setColumnValues(2, value[index].children[0].children);
        // 选择第一列时，如果第二列和第三列没有选择第一个，就更改选中
        if (areaList.value[1].defaultIndex > 0 || areaList.value[2].defaultIndex > 0) {
          areaList.value[1].defaultIndex = 0;
          areaList.value[2].defaultIndex = 0;
        }
      } else if (index == 1) {
        picker.value.setColumnValues(2, value[index].children);
        areaList.value[2].defaultIndex = 0;
      }
    };
    // 选择省市区事件
    const res_time = ref(''); // 开始时间
    const end_time = ref(''); // 结束时间
    const timeSelected = ref(''); // 时间选中
    const dateRef = ref(null);
    const areaChoose = value => {
      let checked = value[0].text + '/' + value[1].text + '/' + value[2].text;
      // 地址没变化
      if (areaSelected.value == checked) return;
      street.value = address.value = '';
      // 地址选中赋值
      areaSelected.value = checked;
      // sa_id赋值
      sa_id.value = value[2].sa_id;
      city_code.value = value[2].city_code;
      district_code.value = value[2].area_code;
      showArea.value = false;
      if (res_time.value) {
        // 选择地址后重新请求服务日期
        dateRef.value.getValuableDate(orderDetail.value, sa_id.value, resPhone.value);
        // 选择完地址清空时间
        res_time.value = end_time.value = timeSelected.value = '';
      }
      getStreetList();
    };
    // 获取街道列表
    const defaultStreetIndex = ref(0); // 街道默认选中
    const streetList = ref([]);
    const getStreetList = () => {
      streetList.value = [];
      proxy.$api.post(`${proxy.$url}Area/getServiceStreet`, {
        st_id: orderDetail.value.st_id,
        sa_id: sa_id.value
      }).then(res => {
        if (Array.isArray(res.data) && res.data.length > 0) {
          streetList.value = res.data;
          if (streetList.value.length > 0 && orderDetail.value.street_id > 0) {
            defaultStreetIndex.value = streetList.value.findIndex(item => item.street_id == orderDetail.value.street_id);
          } else {
            defaultStreetIndex.value = 0;
          }
        } else {
          commonMethod.notify('warning', '街道列表获取失败');
        }
      }).catch(() => {
        commonMethod.notify('warning', '街道列表获取失败');
      });
    };
    // 选择街道
    const street_id = ref(0);
    const showStreet = ref(false);
    const streetChoose = value => {
      if (value.usable == 0) {
        commonMethod.notify('warning', '此街道无法服务');
        return;
      }
      street_id.value = value.street_id;
      street.value = value.text;
      showStreet.value = false;
    };
    // 选择时间
    const showTime = ref(false); // 展示时间弹窗
    const getDate = () => {
      showTime.value = true;
      nextTick(() => {
        dateRef.value.getValuableDate(orderDetail.value, sa_id.value, resPhone.value);
      });
    };
    // 选择时间
    const chooseDate = (show, start, end) => {
      showTime.value = false;
      timeSelected.value = show;
      res_time.value = start;
      end_time.value = end;
    };
    // 提交预约
    const adr = ref(null);
    const name = ref(null);
    const phone = ref(null);
    const toSave = () => {
      if (orderDetail.value.st_id == 1) {
        if (!brand_id.value) {
          commonMethod.notify('warning', '请选择家电品牌');
          return;
        }
        if (orderDetail.value.s_id == 10 || orderDetail.value.s_id == 11 || orderDetail.value.s_id == 20) {
          if (hood_type.value != 1 && hood_type.value != 2) {
            commonMethod.notify('warning', '请选择油烟机类型');
            return;
          }
        }
      }
      if (orderDetail.value.st_id == 3) {
        if (!house_type1.value || !house_type2.value || !house_type3.value) {
          commonMethod.notify('warning', '请填写户型类别');
          return;
        }
        if (Number(house_type1.value) <= 0 || Number(house_type2.value) <= 0 || Number(house_type3.value) <= 0) {
          commonMethod.notify('warning', '请填写正确的户型类别');
          return;
        }
      }
      if (!areaSelected.value) {
        commonMethod.notify('warning', '请选择地址');
        return;
      }
      if (!street.value) {
        commonMethod.notify('warning', '请选择街道');
        return;
      }
      if (!address.value) {
        commonMethod.notify('warning', '请填写详情地址');
        adr.value.focus();
        return;
      }
      if (!res_time.value || res_time.value == '' || res_time.value == null) {
        commonMethod.notify('warning', '请选择期望上门时间');
        return;
      }
      if (resName.value == '' || resName.value == null) {
        commonMethod.notify('warning', '请填写联系人姓名');
        name.value.focus();
        return;
      }
      if (!/^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[0-9]{1})|(19[0-9]{1})|(18[0-9]{1}))+\d{8})$/.test(resPhone.value)) {
        commonMethod.notify('warning', '手机号码错误');
        phone.value.focus();
        return;
      }
      toSubmit();
    };
    // 请求提交预约接口
    const toSubmit = () => {
      let house_type = '';
      if (orderDetail.value.st_id == 3) {
        house_type = house_type1.value + '室' + house_type2.value + '厅' + house_type3.value + '卫';
      }
      commonMethod.toast('loading', '正在提交...', 0);
      proxy.$api.post(`${proxy.$url}ExpApi/toSave`, {
        soi_id: orderDetail.value.soi_id,
        sa_id: sa_id.value,
        brand_id: brand_id.value,
        h_type: hood_type.value,
        c_name: resName.value,
        c_phone: resPhone.value,
        street_id: street_id.value,
        address: address.value,
        res_time: res_time.value,
        end_time: end_time.value,
        remark: remark.value,
        uCode: orderDetail.value.shorturl,
        house_type
      }).then(res => {
        commonMethod.toast('clear');
        if (res.status == 1) {
          router.replace({
            path: '/reserved/' + route.params.su
          });
        } else {
          commonMethod.notify('warning', '预约失败');
        }
        window.localStorage.clear();
      }).catch(err => {
        commonMethod.toast('clear');
        commonMethod.toast('', '预约失败');
      });
    };
    // 返回上一页
    const back = () => {
      window.history.go(-1);
    };
    return (_ctx, _cache) => {
      const _component_van_nav_bar = _resolveComponent("van-nav-bar");
      const _component_van_field = _resolveComponent("van-field");
      const _component_van_picker = _resolveComponent("van-picker");
      const _component_van_popup = _resolveComponent("van-popup");
      const _component_van_radio = _resolveComponent("van-radio");
      const _component_van_radio_group = _resolveComponent("van-radio-group");
      const _component_van_overlay = _resolveComponent("van-overlay");
      const _component_van_button = _resolveComponent("van-button");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [orderDetail.value.is_hide_nav == 0 ? (_openBlock(), _createBlock(_component_van_nav_bar, {
        key: 0,
        title: "服务预约",
        "left-arrow": "",
        border: "",
        fixed: "",
        placeholder: "",
        onClickLeft: back
      })) : _createCommentVNode("", true), _createVNode(_component_van_field, {
        label: "服务类型",
        modelValue: orderDetail.value.s_name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => orderDetail.value.s_name = $event),
        readonly: ""
      }, null, 8, ["modelValue"]), isjiadian.value ? (_openBlock(), _createBlock(_component_van_field, {
        key: 1,
        label: "家电品牌",
        modelValue: brand_name.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => brand_name.value = $event),
        readonly: "",
        clickable: "",
        placeholder: "选择家电品牌",
        onClick: _cache[2] || (_cache[2] = $event => showBrand.value = true)
      }, null, 8, ["modelValue"])) : _createCommentVNode("", true), _createVNode(_component_van_popup, {
        show: showBrand.value,
        "onUpdate:show": _cache[4] || (_cache[4] = $event => showBrand.value = $event),
        position: "bottom"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_picker, {
          "show-toolbar": "",
          columns: brandsList.value,
          "value-key": 'name',
          onConfirm: brandConfirm,
          onCancel: _cache[3] || (_cache[3] = $event => showBrand.value = false)
        }, null, 8, ["columns"])]),
        _: 1
      }, 8, ["show"]), isHood.value ? (_openBlock(), _createBlock(_component_van_field, {
        key: 2,
        label: "家电类型"
      }, {
        input: _withCtx(() => [_createVNode(_component_van_radio_group, {
          modelValue: hood_type.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => hood_type.value = $event),
          direction: "horizontal",
          onChange: hoodsConfirm
        }, {
          default: _withCtx(() => [_createVNode(_component_van_radio, {
            name: "1",
            "checked-color": "#b50029",
            "icon-size": "16px"
          }, {
            default: _withCtx(() => [_createTextVNode("侧吸")]),
            _: 1
          }), _createVNode(_component_van_radio, {
            name: "2",
            "checked-color": "#b50029",
            "icon-size": "16px"
          }, {
            default: _withCtx(() => [_createTextVNode("直吸")]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_component_van_field, {
        label: "省市区",
        modelValue: areaSelected.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => areaSelected.value = $event),
        readonly: "",
        clickable: "",
        onClick: _cache[7] || (_cache[7] = $event => showArea.value = true),
        placeholder: "选择省市区",
        class: "adr"
      }, null, 8, ["modelValue"]), _createVNode(_component_van_popup, {
        show: showArea.value,
        "onUpdate:show": _cache[9] || (_cache[9] = $event => showArea.value = $event),
        position: "bottom",
        style: {
          height: '40%'
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_van_picker, {
          "show-toolbar": "",
          columns: areaList.value,
          "default-index": defaultIndex.value,
          onChange: areaChange,
          onConfirm: areaChoose,
          onCancel: _cache[8] || (_cache[8] = $event => showArea.value = false),
          ref_key: "picker",
          ref: picker
        }, null, 8, ["columns", "default-index"])]),
        _: 1
      }, 8, ["show"]), _createVNode(_component_van_field, {
        label: "街道名称",
        modelValue: street.value,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => street.value = $event),
        readonly: "",
        clickable: "",
        onClick: _cache[11] || (_cache[11] = $event => showStreet.value = true),
        placeholder: "选择街道",
        class: "adr"
      }, null, 8, ["modelValue"]), _createVNode(_component_van_popup, {
        show: showStreet.value,
        "onUpdate:show": _cache[13] || (_cache[13] = $event => showStreet.value = $event),
        position: "bottom",
        style: {
          height: '40%'
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_van_picker, {
          "show-toolbar": "",
          columns: streetList.value,
          "default-index": defaultStreetIndex.value,
          onConfirm: streetChoose,
          onCancel: _cache[12] || (_cache[12] = $event => showStreet.value = false)
        }, null, 8, ["columns", "default-index"])]),
        _: 1
      }, 8, ["show"]), _createVNode(_component_van_field, {
        label: "详细地址",
        modelValue: address.value,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => address.value = $event),
        placeholder: "填写详细地址",
        ref_key: "adr",
        ref: adr,
        class: "adr"
      }, null, 8, ["modelValue"]), orderDetail.value.st_id == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_van_field, {
        label: "户型类别",
        readonly: "",
        style: {
          "margin-right": "15px"
        },
        class: "not_border"
      }), _createVNode(_component_van_field, {
        "label-width": 1,
        modelValue: house_type1.value,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => house_type1.value = $event),
        "input-align": "center",
        label: "",
        type: "number",
        placeholder: "2"
      }, null, 8, ["modelValue"]), _hoisted_3, _createVNode(_component_van_field, {
        "label-width": 1,
        modelValue: house_type2.value,
        "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => house_type2.value = $event),
        "input-align": "center",
        label: "",
        type: "number",
        placeholder: "1"
      }, null, 8, ["modelValue"]), _hoisted_4, _createVNode(_component_van_field, {
        "label-width": 1,
        modelValue: house_type3.value,
        "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => house_type3.value = $event),
        "input-align": "center",
        label: "",
        type: "number",
        placeholder: "1"
      }, null, 8, ["modelValue"]), _hoisted_5])) : _createCommentVNode("", true), _createVNode(_component_van_field, {
        label: "期望上门时间",
        modelValue: timeSelected.value,
        "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => timeSelected.value = $event),
        readonly: "",
        clickable: "",
        placeholder: "选择期望上门时间",
        onClick: getDate,
        style: _normalizeStyle({
          color: timeSelected.value == '选择期望上门时间' ? '#999' : '#333'
        })
      }, null, 8, ["modelValue", "style"]), _createVNode(_component_van_overlay, {
        show: showTime.value,
        onClick: _cache[20] || (_cache[20] = $event => showTime.value = false),
        "lock-scroll": false
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          onClick: _cache[19] || (_cache[19] = _withModifiers(() => {}, ["stop"]))
        }, [_createVNode(Date, {
          ref_key: "dateRef",
          ref: dateRef,
          onChooseDate: chooseDate,
          isjiadian: isjiadian.value,
          channel: 'h5'
        }, null, 8, ["isjiadian"])])]),
        _: 1
      }, 8, ["show"]), _createVNode(_component_van_field, {
        label: "联系人",
        modelValue: resName.value,
        "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => resName.value = $event),
        placeholder: "输入联系人姓名",
        ref_key: "name",
        ref: name
      }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
        label: "手机号",
        modelValue: resPhone.value,
        "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => resPhone.value = $event),
        placeholder: "输入手机号码",
        maxlength: "11",
        type: "tel",
        ref_key: "phone",
        ref: phone
      }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
        label: "备注",
        modelValue: remark.value,
        "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => remark.value = $event),
        placeholder: "输入备注",
        maxlength: "100",
        type: "textarea",
        rows: "2",
        autosize: "",
        "show-word-limit": ""
      }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_6, [_hoisted_7, _hoisted_8, _createElementVNode("span", {
        class: "serviceNo",
        onClick: _cache[24] || (_cache[24] =
        //@ts-ignore
        (...args) => _ctx.call && _ctx.call(...args))
      }, "服务热线：40066-31115")]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_van_button, {
        round: "",
        block: "",
        color: orderDetail.value.is_over_days ? '#ccc' : '#b50029',
        onClick: toSave
      }, {
        default: _withCtx(() => [_createTextVNode("提交预约")]),
        _: 1
      }, 8, ["color"])])]), _createVNode(_component_van_overlay, {
        show: overlayShow.value,
        "custom-style": {
          background: 'rgba(255,255,255,0.3)'
        }
      }, null, 8, ["show"])], 64);
    };
  }
});